import ComponentManager, {ComponentOptions, ComponentOptionsValuePlaceholder} from "../../componentFramework";
import JsfJsCommand from "../JsfJsCommand";
import EditContentNodes from "../EditContentNodes";

const defaultOptions = {
	nodeId: ComponentOptionsValuePlaceholder.number.required
};
export type DefaultOptionsType = typeof defaultOptions;

@ComponentManager.register({requires: () => EditContentNodes})
export default class EditContentNodeControls {
	public static componentStyleClass = "editContentNodeControls";

	private static instances: Map<number, EditContentNodeControls>;

	protected readonly options: ComponentOptions<DefaultOptionsType>;

	static getInstance(nodeId: number): EditContentNodeControls | undefined {
		return EditContentNodeControls.instances.get(nodeId);
	}

	@ComponentManager.on("beforeFirstConstruction")
	public static beforeFirstConstruction() {
		EditContentNodeControls.instances = new Map();
	};

	constructor(private readonly rootElement: HTMLElement) {
		this.options = new ComponentOptions(this, rootElement, defaultOptions);

		EditContentNodeControls.instances.set(this.options.getValues().nodeId, this);
	}

	@ComponentManager.on("removed")
	protected removed() {
		const instance = EditContentNodeControls.instances.get(this.options.getValues().nodeId);
		if (instance === this) {
			EditContentNodeControls.instances.delete(this.options.getValues().nodeId);
		}
	}

	/**
	 * This will update the focus for edit content node this control is for.
	 * Various components watch for the "focusChange" event and update based
	 * on it.
	 * If you call focus() on EditContentNode it will actually call
	 * this method to do the actual update.
	 */
	public focus() {
		JsfJsCommand.run("focus", this.rootElement);
		EditContentNodes.notifyFocusChange(this.options.getValues().nodeId);
	}
}
